import { render, staticRenderFns } from "./SimpleBottomSheetMenu.vue?vue&type=template&id=49f781f0&scoped=true"
import script from "./SimpleBottomSheetMenu.vue?vue&type=script&lang=js"
export * from "./SimpleBottomSheetMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f781f0",
  null
  
)

export default component.exports